import React from "react";
import { useDispatch, useSelector } from "react-redux";
import CompanyAndNewsEvent from "./FutureEventsIcons/CompanyAndNewsEvent.jsx";
import CriticalEvent from "./FutureEventsIcons/CriticalEvent.jsx";
import ProductAndNewsEvent from "./FutureEventsIcons/ProductAndNewsEvent.jsx";
import GovernmentRegulatory from "./FutureEventsIcons/GovernmentRegulatory.jsx";
import IndustryEvent from "./FutureEventsIcons/IndustryEvent.jsx";
import { RiPanelConstants } from "../../../../../Constants/RiPanelConstants.js";
import { OverlayTrigger, Popover } from "react-bootstrap";

const { ActionTypes } = RiPanelConstants;

const RiPanelFutureEvents = ({ handleToggle, isFutureEventOn, isFutureEventAIApplicable }) => {
  const dispatch = useDispatch();
  const viewsSettings = useSelector(
    (state) => state.RelatedInfoPanelReducers.RiPanelAI.aiSettings
  );
  const handleFutureEventToggle = (futureEvent) => {
    dispatch({
      type: ActionTypes.UPDATE_FUTURE_EVENTS_ALLOWED,
      futureEvent,
    });
  };
  const eventTypes = [
    {
      id: "Critical",
      label: "Critical Events",
      icon: (
        <CriticalEvent
          className={viewsSettings?.futureEvent?.eventsAllowed?.Critical ? "selected" : "not-selected"}
          fontSize="15px"
        />
      ),
      description:
        "Earnings release, FOMC, index inclusion/exclusion, litigation, lock-up expiration",
      defaultChecked:
        viewsSettings?.futureEvent?.eventsAllowed?.Critical ?? true,
    },
    {
      id: "CompanyNews",
      label: "Company News & Events",
      icon: (
        <CompanyAndNewsEvent
          className={viewsSettings?.futureEvent?.eventsAllowed?.CompanyNews ? "selected" : "not-selected"}
          fontSize="15px"
        />
      ),
      description:
        "10k, analyst meeting, corporate governance, debt, dividends, investor day, legal, lock-up expiration, M&A, proxy vote, regulatory, restructuring, shareholder meeting, strategic initiatives, trade shows & conferences.",
      defaultChecked:
        viewsSettings?.futureEvent?.eventsAllowed?.CompanyNews ?? true,
    },
    {
      id: "ProductNews",
      label: "Product News & Events",
      icon: (
        <ProductAndNewsEvent
          className={viewsSettings?.futureEvent?.eventsAllowed?.ProductNews ? "selected" : "not-selected"}
          fontSize="15px"
        />
      ),
      description:
        "Patent decision or expiration, product announcements, launch and delays.",
      defaultChecked:
        viewsSettings?.futureEvent?.eventsAllowed?.ProductNews ?? true,
    },
    {
      id: "Industry",
      label: "Industry",
      icon: (
        <IndustryEvent
          className={viewsSettings?.futureEvent?.eventsAllowed?.Industry ? "selected" : "not-selected"}
          fontSize="15px"
        />
      ),
      description: "Industry & competitor events.",
      defaultChecked:
        viewsSettings?.futureEvent?.eventsAllowed?.Industry ?? true,
    },
    {
      id: "GovernmentRegulations",
      label: "Government Regulatory",
      icon: (
        <GovernmentRegulatory
          className={viewsSettings?.futureEvent?.eventsAllowed?.GovernmentRegulations ? "selected" : "not-selected"}
          fontSize="15px"
        />
      ),
      description:
        "Company relevant policy and regulatory decisions by FTC, FDA, FCC, FAA, EPA.",
      defaultChecked:
        viewsSettings?.futureEvent?.eventsAllowed?.GovernmentRegulations ??
        true,
    },
  ];
  return (
    <>
      <div className={`toggle-section ${isFutureEventAIApplicable ? "" : "option-disabled"}`} style={{ paddingBottom: "0px" }}>
        <div className="on-off-switch">
          <label className="switch" onClick={isFutureEventAIApplicable && handleToggle}>
            <div
              className={
                isFutureEventOn ? "toggle-switch active" : "toggle-switch"
              }
              id="toggleSwitch"
            >
              <div className="switch-circle"></div>
              <span className="toggle-text off">OFF</span>
              <span className="toggle-text on">ON</span>
            </div>
          </label>
        </div>
        <span className="title">Display Future Events</span>
      </div>
      <div className="content" style={{ marginTop: "20px" }}>Click icon to turn event types on or off</div>
      <div className="sections">
        <div className={`section ${isFutureEventAIApplicable ? "" : "option-disabled"}`}>
          {eventTypes.map(
            ({ id, label, icon, description, defaultChecked }) => (
              <div
                key={id}
                style={{
                  display: "flex",
                  marginBottom: "4px",
                  marginLeft: defaultChecked ? "20px" : "0px",
                  marginRight: "10px",
                }}
              >
                {!defaultChecked && <div className="off-indicator" style={{ marginTop: "4px" }}>OFF</div>}
                <div
                  className="event-icon"
                  style={{ marginRight: "8px", cursor: "pointer", marginTop: "2.5px", height: "15px" }}
                  onClick={() => isFutureEventAIApplicable && handleFutureEventToggle(id)}
                >
                  {icon}
                </div>

                {isFutureEventAIApplicable ? (
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 100 }}
                    overlay={<Popover id={`tooltip-${id}`} className="future-event-details-tooltip" style={{ maxWidth: "250px", textAlign: "center" }}>{description}</Popover>}
                  >
                    <div className="future-content">
                      <strong className="title">{label}</strong>
                    </div>
                  </OverlayTrigger>
                ) : (
                  <div className="future-content">
                    <strong className="title">{label}</strong>
                  </div>
                )}
              </div>
            )
          )}
        </div>
      </div>
    </>
  );
};

export default RiPanelFutureEvents;
